module.exports = __webpack_public_path__ + "static/media/LS021B7DD02_Spec_LCP-0620032_201201.fcd0a40e.pdf";